import { jellyTriangle } from 'ldrs'

const LoadingScreen = () => {
  jellyTriangle.register()

  return (
    <div className='flex h-screen w-full items-center justify-center bg-background'>
      <l-jelly-triangle size='30' speed='1.75' color='gray'></l-jelly-triangle>
    </div>
  )
}

export default LoadingScreen
